/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Toggletheme1Inputs */

const he_common_toggletheme1 = /** @type {(inputs: Common_Toggletheme1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`החלף ערכת נושא`)
};

const en_common_toggletheme1 = /** @type {(inputs: Common_Toggletheme1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle theme`)
};

/**
* | output |
* | --- |
* | "Toggle theme" |
*
* @param {Common_Toggletheme1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_toggletheme1 = /** @type {((inputs?: Common_Toggletheme1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Toggletheme1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_toggletheme1(inputs)
	return en_common_toggletheme1(inputs)
});
export { common_toggletheme1 as "common_toggleTheme" }